import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getCurrentLang, getLocalizedUrl, getSwitchLangUrl, SUPPORTED_LANGUAGES } from '../utils/languageHelper';
import ServiceSearch from './serviceSearch';

const Header = props => {
  const pathname = (props.location && props.location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '/');
  const currentLang = getCurrentLang(pathname, props.intl);
  const activeLangObj = SUPPORTED_LANGUAGES.find(l => l.code === currentLang) || SUPPORTED_LANGUAGES[0];

  const handleDropdownClick = e => {
    e.preventDefault();
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark">
        <a className="navbar-brand" href={getLocalizedUrl('/', currentLang)}>
          <img src="/logo32.png" alt="Text Case Convert" className="logo" />Text Case Convert
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarCollapse">
          <ul className="navbar-nav ml-auto align-items-lg-center">
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="textToolsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.textTools" defaultMessage="Text Tools" />
              </a>
              <div className="dropdown-menu" aria-labelledby="textToolsDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/replace-text', currentLang)}>
                  <FormattedMessage id="nav.textReplacer" defaultMessage="Text Replacer" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/remove-duplicate-lines', currentLang)}>
                  <FormattedMessage id="nav.duplicateRemover" defaultMessage="Duplicate Line Remover" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/markdown-to-html', currentLang)}>
                  <FormattedMessage id="nav.markdownToHtml" defaultMessage="Markdown to HTML" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/html-to-markdown', currentLang)}>
                  <FormattedMessage id="nav.htmlToMarkdown" defaultMessage="HTML to Markdown" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/lorem-ipsum', currentLang)}>
                  <FormattedMessage id="nav.loremIpsum" defaultMessage="Lorem Ipsum Generator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/character-count', currentLang)}>
                  <FormattedMessage id="nav.characterCount" defaultMessage="Character Count" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/tally-counter', currentLang)}>
                  <FormattedMessage id="nav.tallyCounter" defaultMessage="Tally Counter" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/diff-checker', currentLang)}>
                  <FormattedMessage id="nav.diffChecker" defaultMessage="Diff Checker (Text Compare)" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="codeToolsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.codeData" defaultMessage="Code & Data" />
              </a>
              <div className="dropdown-menu" aria-labelledby="codeToolsDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/json-pretty-print', currentLang)}>
                  <FormattedMessage id="nav.jsonPretty" defaultMessage="JSON Pretty Print" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/xml-pretty-print', currentLang)}>
                  <FormattedMessage id="nav.xmlPretty" defaultMessage="XML Pretty Print" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/html-formatter', currentLang)}>
                  <FormattedMessage id="nav.htmlFormatter" defaultMessage="HTML Formatter" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/css-beautifier', currentLang)}>
                  <FormattedMessage id="nav.cssBeautifier" defaultMessage="CSS Beautifier" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/code-minifier', currentLang)}>
                  <FormattedMessage id="nav.codeMinifier" defaultMessage="Code Minifier (CSS/JS)" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/json-to-csv', currentLang)}>
                  <FormattedMessage id="nav.jsonToCsv" defaultMessage="JSON to CSV / Excel" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/csv-to-json', currentLang)}>
                  <FormattedMessage id="nav.csvToJson" defaultMessage="CSV to JSON" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/base64-converter', currentLang)}>
                  <FormattedMessage id="nav.base64Converter" defaultMessage="Base64 Converter" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/image-to-webp', currentLang)}>
                  <FormattedMessage id="nav.imageToWebp" defaultMessage="Image to WebP (PNG/JPG)" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/jwt-decoder', currentLang)}>
                  <FormattedMessage id="nav.jwtDecoder" defaultMessage="JWT Decoder & Inspector" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/cron-expression-generator', currentLang)}>
                  <FormattedMessage id="nav.cronGenerator" defaultMessage="Cron Expression Generator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/sql-formatter', currentLang)}>
                  <FormattedMessage id="nav.sqlFormatter" defaultMessage="SQL Formatter & Beautifier" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/regex-tester', currentLang)}>
                  <FormattedMessage id="nav.regexTester" defaultMessage="Regex Tester & Simulator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/exif-remover', currentLang)}>
                  <FormattedMessage id="nav.exifRemover" defaultMessage="EXIF Metadata Remover" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="securityToolsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.security" defaultMessage="Security" />
              </a>
              <div className="dropdown-menu" aria-labelledby="securityToolsDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/password-generator', currentLang)}>
                  <FormattedMessage id="nav.passwordGenerator" defaultMessage="Password Generator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/password-strength-checker', currentLang)}>
                  <FormattedMessage id="nav.passwordStrength" defaultMessage="Password Strength Checker" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/hash-generator', currentLang)}>
                  <FormattedMessage id="nav.hashGenerator" defaultMessage="Cryptographic Hash Generator" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.calculators" defaultMessage="Calculators" />
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/calculator', currentLang)}>
                  <FormattedMessage id="nav.simpleCalculator" defaultMessage="Simple Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/time-calculator', currentLang)}>
                  <FormattedMessage id="nav.timeCalculator" defaultMessage="Time Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/compound-interest-calculator', currentLang)}>
                  <FormattedMessage id="nav.compoundInterest" defaultMessage="Compound Interest Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/profit-margin-calculator', currentLang)}>
                  <FormattedMessage id="nav.profitMargin" defaultMessage="Profit Margin & Markup" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/freelance-rate-calculator', currentLang)}>
                  <FormattedMessage id="nav.freelanceRate" defaultMessage="Freelance Rate Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/cpm-calculator', currentLang)}>
                  <FormattedMessage id="nav.cpmCalculator" defaultMessage="Paid Media & CPM Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/debt-payoff-calculator', currentLang)}>
                  <FormattedMessage id="nav.debtPayoff" defaultMessage="Debt Payoff Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/mortgage-calculator', currentLang)}>
                  <FormattedMessage id="nav.mortgageCalc" defaultMessage="Mortgage Calculator & Schedule" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/car-insurance-calculator', currentLang)}>
                  <FormattedMessage id="nav.insuranceCalc" defaultMessage="Car & Life Insurance Calculator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/unit-converter', currentLang)}>
                  <FormattedMessage id="nav.unitConverter" defaultMessage="Unit Converter (Inches to CM, Lbs to KG)" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/temperature-converter', currentLang)}>
                  <FormattedMessage id="nav.tempConverter" defaultMessage="Temperature Converter (°F to °C)" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="marketingDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.marketing" defaultMessage="Marketing & SEO" />
              </a>
              <div className="dropdown-menu" aria-labelledby="marketingDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/utm-builder', currentLang)}>
                  <FormattedMessage id="nav.utmBuilder" defaultMessage="UTM Campaign Builder" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/open-graph-preview', currentLang)}>
                  <FormattedMessage id="nav.openGraphPreview" defaultMessage="Open Graph & Social Preview" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/qr-code-generator', currentLang)}>
                  <FormattedMessage id="nav.qrCode" defaultMessage="QR Code Generator" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="translatorsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.translators" defaultMessage="Translators" />
              </a>
              <div className="dropdown-menu" aria-labelledby="translatorsDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/morse-code', currentLang)}>
                  <FormattedMessage id="nav.morseCode" defaultMessage="Morse Code Translator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/binary-code-translator', currentLang)}>
                  <FormattedMessage id="nav.binaryCode" defaultMessage="Binary Code Translator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/wingdings-translator', currentLang)}>
                  <FormattedMessage id="nav.wingdings" defaultMessage="Wingding Translator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/base64-converter', currentLang)}>
                  <FormattedMessage id="nav.base64Converter" defaultMessage="Base64 Translator" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="uuidDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.uuidTools" defaultMessage="UUID Tools" />
              </a>
              <div className="dropdown-menu" aria-labelledby="uuidDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/uuid-generator', currentLang)}>
                  <FormattedMessage id="nav.uuidGenerator" defaultMessage="UUID Generator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/uuid-formatter', currentLang)}>
                  <FormattedMessage id="nav.uuidFormatter" defaultMessage="UUID Formatter" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/uuid-validator', currentLang)}>
                  <FormattedMessage id="nav.uuidValidator" defaultMessage="UUID Validator" />
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" onClick={handleDropdownClick} id="randomDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FormattedMessage id="nav.random" defaultMessage="Random" />
              </a>
              <div className="dropdown-menu" aria-labelledby="randomDropdown">
                <a className="dropdown-item" href={getLocalizedUrl('/wheel-decide', currentLang)}>
                  <FormattedMessage id="nav.wheelDecide" defaultMessage="Wheel Decide" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/random-name', currentLang)}>
                  <FormattedMessage id="nav.randomName" defaultMessage="Random Name Generator" />
                </a>
                <a className="dropdown-item" href={getLocalizedUrl('/random-number', currentLang)}>
                  <FormattedMessage id="nav.randomNumber" defaultMessage="Random Number Generator" />
                </a>
              </div>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/blog">Blog</a>
            </li>

            {/* Service Search Box */}
            <li className="nav-item my-1 my-lg-0 ml-lg-2 d-flex align-items-center header-search-item">
              <ServiceSearch currentLang={currentLang} />
            </li>

            {/* Language Selector Dropdown */}
            <li className="nav-item dropdown ml-lg-2 my-1 my-lg-0 d-flex align-items-center header-lang-item">
              <a
                className="dropdown-toggle btn btn-sm btn-outline-secondary text-light px-2 d-inline-flex align-items-center justify-content-center header-lang-btn"
                href="/"
                onClick={handleDropdownClick}
                id="languageDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title={props.intl.formatMessage({ id: 'header.change_language', defaultMessage: 'Change language' })}
                style={{ height: '31px', fontSize: '13px', lineHeight: '1' }}
              >
                <span className="mr-1">{activeLangObj.flag}</span>
                <span className="text-uppercase">{activeLangObj.code}</span>
              </a>
              <div className="dropdown-menu dropdown-menu-right header-lang-menu" aria-labelledby="languageDropdown">
                {SUPPORTED_LANGUAGES.map(item => (
                  <a
                    key={item.code}
                    className={`dropdown-item ${currentLang === item.code ? 'active font-weight-bold' : ''}`}
                    href={getSwitchLangUrl(item.code, pathname)}
                  >
                    <span className="mr-2">{item.flag}</span>
                    {item.label}
                  </a>
                ))}
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default withRouter(injectIntl(Header));